import { Theme } from '@desygner/ui-common-components';

import { Overlay } from './Color';

export const { Size, Padding, Margin } = Theme.Modal;

export const OverlayColor = Overlay.Light;
